import {HStack, VStack} from "@styled-system/jsx";
import AccentCard from '~/routes/promotions.$promotionId/AccentCard';
import {useEffect, useState} from 'react';
import {Temporal} from 'temporal-polyfill'
import {css} from '@styled-system/css';

type DateCardProps = {
  endDate: Date
}

const StackedNumber = ({num, label}: { num: number, label: string }) => {
  return <VStack gap={0}>
    <div className={css({fontFamily: 'heading', fontWeight: 'semibold'})}>
      {num < 10 && '0'}{num}
    </div>
    <div className={css({fontSize: 'sm', textAlpha: 'blue.900/60'})}>
      {label}
    </div>
  </VStack>
}

const CountdownCard = ({endDate}: DateCardProps) => {
  const [countdown, setCountdown] = useState<Temporal.Duration | undefined>()

  const endTime = Temporal.PlainDate.from({
    year: endDate.getUTCFullYear(),
    month: endDate.getUTCMonth() + 1,
    day: endDate.getUTCDate()
  })
    .add({days: 1})
    .toZonedDateTime({plainTime: new Temporal.PlainTime(0), timeZone: 'America/Los_Angeles'});

  useEffect(() => {
    const interval = setInterval(() => {
      const duration = endTime.since(Temporal.Now.zonedDateTimeISO('America/Los_Angeles'), {largestUnit: 'day'})
      setCountdown(duration)
      if (duration.sign < 0) {
        clearInterval(interval);
        return;
      }
    }, 500);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endTime.toString()]);

  return <AccentCard>
    {countdown && countdown.sign >= 0 && (
      <HStack alignItems="center" justifyContent="center" color="blue.900">
        <StackedNumber num={countdown.days} label="Days"/>
        :
        <StackedNumber num={countdown.hours} label="Hrs"/>
        :
        <StackedNumber num={countdown.minutes} label="Min"/>
        :
        <StackedNumber num={countdown.seconds} label="Sec"/>
      </HStack>
    )}
    {countdown && countdown.sign < 0 && (
      <div className={css({
        fontFamily: 'heading',
        fontWeight: 'semibold',
        color: 'primary',
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: 'lg',
      })}>
        Ended
      </div>
    )}
  </AccentCard>
}

export default CountdownCard;
